import React, { useState, FunctionComponent, useEffect } from 'react';
import { Presentation } from './presentation';

type Props = {
  onChangedBody: (name: string, value: any) => void;
  body: string;
  target: string;
  fromEntry?: boolean;
};

export const Component: FunctionComponent<Props> = ({
  onChangedBody,
  body,
  target,
  fromEntry,
}) => {
  const [text, setText] = useState(body || '');

  useEffect(() => {
    setText(body || '');
  }, [body]);

  const handleChange = (name: string, value: string) => {
    setText(value);
    onChangedBody(target, value);
  };

  return (
    <Presentation
      target={target}
      text={text}
      handleChange={handleChange}
      fromEntry={fromEntry}
    />
  );
};
